import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { contactAPI } from '../services/api';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    city: 'Санкт-Петербург',
    telegram_username: '',
    phone: '',
    contact_method: 'Telegram',
    services_interested: [],
    consent_given: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const response = await contactAPI.submit(formData);
      console.log('Form submitted successfully:', response);
      setSubmitted(true);
      
      // Reset form after 4 seconds
      setTimeout(() => {
        setSubmitted(false);
        setFormData({
          name: '',
          city: 'Санкт-Петербург',
          telegram_username: '',
          phone: '',
          contact_method: 'Telegram',
          services_interested: [],
          consent_given: false
        });
      }, 4000);
    } catch (err) {
      console.error('Form submission error:', err);
      setError(err.response?.data?.detail || 'Произошла ошибка. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  const handleServiceToggle = (value) => {
    setFormData(prev => ({
      ...prev,
      services_interested: prev.services_interested.includes(value)
        ? prev.services_interested.filter(s => s !== value)
        : [...prev.services_interested, value]
    }));
  };

  if (submitted) {
    return (
      <div style={{
        padding: 'var(--space-xxl)',
        backgroundColor: 'var(--soft-gray)',
        border: '1px solid var(--light-gray)',
        textAlign: 'center'
      }}>
        <h3 style={{
          color: 'var(--black)',
          marginBottom: 'var(--space-l)',
          fontSize: '1.5rem',
          fontFamily: 'var(--font-display)',
          fontWeight: 300
        }}>
          Спасибо за заявку!
        </h3>
        <p style={{ color: 'var(--charcoal)', fontWeight: 300 }}>
          Свяжусь с вами в ближайшее время
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{
      backgroundColor: 'var(--white)',
      padding: 'var(--space-xxl)',
      border: '1px solid var(--soft-gray)',
      textAlign: 'left'
    }}>
      {error && (
        <div style={{
          padding: 'var(--space-m)',
          backgroundColor: '#fdecea',
          border: '1px solid #f5c6cb',
          borderRadius: '4px',
          marginBottom: 'var(--space-l)',
          color: '#721c24'
        }}>
          {error}
        </div>
      )}

      <div style={{ marginBottom: 'var(--space-l)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-s)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Ваше имя *
        </label>
        <input
          type="text"
          required
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          style={{
            width: '100%',
            padding: 'var(--space-m)',
            border: '1px solid var(--soft-gray)',
            fontFamily: 'var(--font-body)',
            fontSize: '1rem',
            backgroundColor: 'var(--white)',
            transition: 'border-color 300ms ease',
            fontWeight: 300
          }}
          className="form-input"
        />
      </div>

      <div style={{ marginBottom: 'var(--space-l)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-s)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Город *
        </label>
        <select
          required
          value={formData.city}
          onChange={(e) => setFormData({ ...formData, city: e.target.value })}
          style={{
            width: '100%',
            padding: 'var(--space-m)',
            border: '1px solid var(--soft-gray)',
            fontFamily: 'var(--font-body)',
            fontSize: '1rem',
            backgroundColor: 'var(--white)',
            transition: 'border-color 300ms ease',
            fontWeight: 300
          }}
          className="form-input"
        >
          <option>Санкт-Петербург</option>
          <option>Москва</option>
          <option>Другой</option>
        </select>
      </div>

      <div style={{ marginBottom: 'var(--space-l)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-s)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Ник в Telegram *
        </label>
        <input
          type="text"
          required
          value={formData.telegram_username}
          onChange={(e) => setFormData({ ...formData, telegram_username: e.target.value })}
          placeholder="@username"
          style={{
            width: '100%',
            padding: 'var(--space-m)',
            border: '1px solid var(--soft-gray)',
            fontFamily: 'var(--font-body)',
            fontSize: '1rem',
            backgroundColor: 'var(--white)',
            transition: 'border-color 300ms ease',
            fontWeight: 300
          }}
          className="form-input"
        />
      </div>

      {/* Phone field */}
      <div style={{ marginBottom: 'var(--space-l)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-s)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Телефон
        </label>
        <input
          type="tel"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="+7 (999) 123-45-67"
          style={{
            width: '100%',
            padding: 'var(--space-m)',
            border: '1px solid var(--soft-gray)',
            fontFamily: 'var(--font-body)',
            fontSize: '1rem',
            backgroundColor: 'var(--white)',
            transition: 'border-color 300ms ease',
            fontWeight: 300
          }}
          className="form-input"
        />
      </div>

      <div style={{ marginBottom: 'var(--space-l)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-s)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Предпочитаемый способ связи *
        </label>
        <select
          required
          value={formData.contact_method}
          onChange={(e) => setFormData({ ...formData, contact_method: e.target.value })}
          style={{
            width: '100%',
            padding: 'var(--space-m)',
            border: '1px solid var(--soft-gray)',
            fontFamily: 'var(--font-body)',
            fontSize: '1rem',
            backgroundColor: 'var(--white)',
            transition: 'border-color 300ms ease',
            fontWeight: 300
          }}
          className="form-input"
        >
          <option>Telegram</option>
          <option>Телефон</option>
        </select>
      </div>

      <div style={{ marginBottom: 'var(--space-xl)' }}>
        <label style={{
          display: 'block',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'var(--charcoal)',
          marginBottom: 'var(--space-m)',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>
          Интересующие услуги *
        </label>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-m)'
        }}>
          {[
            { value: 'wardrobe-analysis', label: 'Разбор гардероба' },
            { value: 'seasonal-capsule', label: 'Сезонная капсула' },
            { value: 'shopping-assistance', label: 'Помощь в шопинге' },
            { value: 'subscription', label: 'Абонемент' }
          ].map((service) => (
            <label key={service.value} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-m)',
              cursor: 'pointer',
              fontFamily: 'var(--font-body)',
              fontSize: '0.9375rem',
              color: 'var(--charcoal)',
              fontWeight: 300
            }}>
              <input
                type="checkbox"
                checked={formData.services_interested.includes(service.value)}
                onChange={() => handleServiceToggle(service.value)}
                style={{
                  width: '18px',
                  height: '18px',
                  cursor: 'pointer'
                }}
              />
              {service.label}
            </label>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 'var(--space-xl)' }}>
        <label style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 'var(--space-m)',
          cursor: 'pointer',
          fontFamily: 'var(--font-body)',
          fontSize: '0.875rem',
          color: 'var(--mid-gray)',
          fontWeight: 300
        }}>
          <input
            type="checkbox"
            required
            checked={formData.consent_given}
            onChange={(e) => setFormData({ ...formData, consent_given: e.target.checked })}
            style={{
              marginTop: '4px',
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              flexShrink: 0
            }}
          />
          <span>
            Я согласен(а) с{' '}
            <Link to="/privacy" style={{ color: 'var(--charcoal)', textDecoration: 'underline' }}>
              политикой обработки персональных данных
            </Link>
          </span>
        </label>
      </div>

      <button 
        type="submit" 
        className="btn-primary" 
        style={{ width: '100%' }}
        disabled={loading}
      >
        <span>{loading ? 'Отправка...' : 'Отправить заявку'}</span>
      </button>

      <style>{`
        .form-input:focus {
          outline: none;
          border-color: var(--accent-gold);
        }
      `}</style>
    </form>
  );
};

export default ContactForm;
